export class Logininfo {
    user_code: number;
    name1: string;
    name2: string;
    division_code: number;
    division_name: string;
    authority_code: number;
    auth: {};
    email: string;
    managed: number;
    is_sales: number;
    is_construction: number;
    is_design: number;
    is_office: number;
    is_admin: number = 0;
    del_customer: number = 0;

    constructor() {
        /*
                this.user_code = 14;
                this.name1 = '鈴木';
                this.name2 = '領馬';
                this.division_code = 1;
                this.division_name = '平屋本舗';
                //this.authority_code = 1;
                this.authority_code = 4;
                this.auth = { "PersonalStatus": true, "AllStatus": true, "EventCalendar": true, "PersonalCalendar": true, "AllCalendar": true, "ClientList": true, "ReservationList": false, "ProcessList": false, "Auth": "GENERAL" };
        */
    }

    getName() {
        if (this.name1 != '' && this.name2 != '') {
            if (this.name2) {
                return this.name1 + ' ' + this.name2;
            } else {
                return this.name1;
            }
        }
        return '';
    }

    clear() {
        this.user_code = 0;
        this.name1 = '';
        this.name2 = '';
        this.division_code = 1;
        this.division_name = '';
        this.authority_code = 1;
        this.del_customer = 0;
        this.is_sales = 0;
        this.is_construction = 0;
        this.is_design = 0;
        this.is_office = 0;
        this.email = '';
        this.auth = { "PersonalStatus": false, "AllStatus": false, "EventCalendar": false, "PersonalCalendar": false, "AllCalendar": false, "ClientList": false, "ReservationList": false, "ProcessList": false, "Auth": "NONE" };
    }
    isEditEventCalender() {
        return true;
    }

    isSystemAdmin() {
        return false;
    }
}